import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, InfoIcon, ExternalLinkIcon } from 'lucide-react';
export function VampDetail() {
  const navigate = useNavigate();
  const [showFraudTooltip, setShowFraudTooltip] = useState(false);
  const [showCardTestingTooltip, setShowCardTestingTooltip] = useState(false);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return <div className="max-w-7xl mx-auto" data-id="element-9293">
      {/* Breadcrumb */}
      <div className="mb-6" data-id="element-9294">
        <button onClick={() => navigate('/card-monitoring')} className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-9295">
          <ChevronLeftIcon size={16} data-id="element-9296" />
          <span data-id="element-9297">Card monitoring programs</span>
        </button>
      </div>

      {/* Header */}
      <div className="mb-8" data-id="element-9298">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-9299">
          Visa Acquirer Monitoring Program (VAMP)
        </h1>
        <p className="text-gray-600" data-id="element-9300">
          View your monitoring program status and history.
        </p>
      </div>

      {/* History Section */}
      <div className="mb-12" data-id="element-9301">
        <div className="flex items-center gap-2 mb-2" data-id="element-9302">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-9303">History</h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-9304">
            <InfoIcon size={16} data-id="element-9305" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-9306">
          Your program history for the last 12 months.
        </p>

        {/* History Table */}
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-9307">
          <table className="w-full" data-id="element-9308">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-9309">
              <tr data-id="element-9310">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-9311">
                  Program type
                </th>
                {months.map(month => <th key={month} className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-9312">
                    {month}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-9313">
              {/* Fraud and disputes row */}
              <tr className="hover:bg-gray-50" data-id="element-9314">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-9315">
                  <div className="flex items-center gap-2" data-id="element-9316">
                    <span className="text-sm text-gray-900" data-id="element-9317">
                      Fraud and disputes
                    </span>
                    <div className="relative" data-id="element-9318">
                      <button onMouseEnter={() => setShowFraudTooltip(true)} onMouseLeave={() => setShowFraudTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-9319">
                        <InfoIcon size={14} data-id="element-9320" />
                      </button>
                      {showFraudTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-9321">
                          Measures fraud and disputes against the total number
                          of settled payments
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-9322"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-9323">
                    {index === 11 ? <div className="flex justify-center" data-id="element-9324">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-9325"></div>
                      </div> : <div className="flex justify-center" data-id="element-9326">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-9327"></div>
                      </div>}
                  </td>)}
              </tr>

              {/* Card testing row */}
              <tr className="hover:bg-gray-50" data-id="element-9328">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-9329">
                  <div className="flex items-center gap-2" data-id="element-9330">
                    <span className="text-sm text-gray-900" data-id="element-9331">Card testing</span>
                    <div className="relative" data-id="element-9332">
                      <button onMouseEnter={() => setShowCardTestingTooltip(true)} onMouseLeave={() => setShowCardTestingTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-9333">
                        <InfoIcon size={14} data-id="element-9334" />
                      </button>
                      {showCardTestingTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-9335">
                          Measures card testing against the total number of
                          settled payments
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-9336"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-9337">
                    {index === 11 ? <div className="flex justify-center" data-id="element-9338">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-9339"></div>
                      </div> : <div className="flex justify-center" data-id="element-9340">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-9341"></div>
                      </div>}
                  </td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Historical and current program status */}
      <div className="mb-12" data-id="element-9342">
        <div className="flex items-center gap-2 mb-2" data-id="element-9343">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-9344">
            Historical and current program status
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-9345">
            <InfoIcon size={16} data-id="element-9346" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-9347">
          Visa-identified fraud and disputes against the total number of settled
          payments
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-9348">
          <p className="text-center text-gray-500" data-id="element-9349">No past history found.</p>
        </div>
      </div>

      {/* Estimated program status */}
      <div className="mb-12" data-id="element-9350">
        <div className="flex items-center gap-2 mb-2" data-id="element-9351">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-9352">
            Estimated program status
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-9353">
            <InfoIcon size={16} data-id="element-9354" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-9355">
          Maybank's estimate of your Visa frauds and disputes. Aim to keep your
          VAMP ratio under 0.5%.{' '}
          <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-9356">
            Learn more
          </a>{' '}
          about how to keep your disputes and fraud low.
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-9357">
          <p className="text-center text-gray-500" data-id="element-9358">No past history found.</p>
        </div>
      </div>

      {/* Resources */}
      <div data-id="element-9359">
        <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-9360">Resources</h2>
        <div className="flex flex-wrap gap-4" data-id="element-9361">
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-9362">
            <ExternalLinkIcon size={14} data-id="element-9363" />
            Program overview
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-9364">
            <ExternalLinkIcon size={14} data-id="element-9365" />
            Preventing fraud and disputes
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-9366">
            <ExternalLinkIcon size={14} data-id="element-9367" />
            Preventing card testing
          </a>
        </div>
      </div>
    </div>;
}